import { useMediaQuery } from 'react-responsive'
import { use100vh, measureHeight } from 'react-div-100vh'
import React, { ReactNode, useEffect, useState } from "react";

type Props = React.PropsWithChildren<{
  responsive: boolean
  children?: ReactNode
}> & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const useMobile = () => {
  return !useMediaQuery({ query: '(min-width: 640px)' })
}

// Fork of https://github.com/mvasin/react-div-100vh/blob/ff4189f041c40a8bbc4adc3571a51c03bf0bb78d/packages/react-div-100vh/src/index.tsx#L5
export function use100vhWithOrientationChanges():  number | null {
  const [height, setHeight] = useState<number | null>(measureHeight)

  const wasRenderedOnClientAtLeastOnce = useWasRenderedOnClientAtLeastOnce()

  useEffect(() => {
    if (!wasRenderedOnClientAtLeastOnce) return

    function setMeasuredHeight() {
      const measuredHeight = measureHeight()
      setHeight(measuredHeight)
    }

    const portrait = window.matchMedia("(orientation: portrait)");
    portrait.addEventListener("change", setMeasuredHeight);
    window.addEventListener('resize', setMeasuredHeight)
    return () => {
			window.removeEventListener('resize', setMeasuredHeight)
    	portrait.removeEventListener("change", setMeasuredHeight);
		}
  }, [wasRenderedOnClientAtLeastOnce])
  return wasRenderedOnClientAtLeastOnce ? height : null
}

function useWasRenderedOnClientAtLeastOnce() {
  const [
    wasRenderedOnClientAtLeastOnce,
    setWasRenderedOnClientAtLeastOnce
  ] = useState(false)

  useEffect(() => {
    if (isClient()) {
      setWasRenderedOnClientAtLeastOnce(true)
    }
  }, [])
  return wasRenderedOnClientAtLeastOnce
}

function isClient() {
  return typeof window !== 'undefined' && typeof document !== 'undefined'
}


export const ResponsiveScreen = ({ responsive, children, ...props }: Props) => {
    const isSm = !useMobile()
    const isTall = useMediaQuery({ query: '(min-height: 1000px)' })
    const isShort = !useMediaQuery({ query: '(min-height: 800px)' })
    const isLandscape = useMediaQuery({ query: '(orientation: landscape)' })
    const fullHeight = use100vhWithOrientationChanges()

    // recalculate height on orientation changes
    let height = fullHeight ? fullHeight : '100vh'
    if(isSm && isTall) {
      height = fullHeight ? fullHeight*0.85 : '75vh'
    }

    const renderResponsive = responsive && !(isShort && isLandscape)

    if(!renderResponsive) {
      return <div {...props}>{children}</div>
    }
    return <div {...props} style={{ height: height }}>{children}</div>
}
